import { render, staticRenderFns } from "./DataRpl.vue?vue&type=template&id=1252d806&"
import script from "./DataRpl.vue?vue&type=script&lang=js&"
export * from "./DataRpl.vue?vue&type=script&lang=js&"
import style0 from "./DataRpl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports